<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        파트너
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리자</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">파트너</a>
        </li>
      </ul>
    </div>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? '정보' : '생성'" border-variant="primary" >
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              파트너 정보
            </div>
            <div class="mb7">
              <span class="pull-right" v-if="!add && model.created_at">가입일  : {{model.created_at | sdate}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" label-for="ph_use">
                로그인 허용
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock" />
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
              <span v-if="model.is_del" class="text-danger">삭제된 사용자이에요. 허용하더라도 로그인이 불가능해요.</span>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="" v-b-tooltip.hover title="'owner' 계정만 청구서 발송을 설정할 수 있어요.">
                이메일 청구서 알림
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Invoice_Email_Notice" :disabled="lock || model.parent_id && model.parent_id != model.id" v-model="model.allow_invoice" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-xl-2 col-md-12  d-flex align-self-center">
              <label class="col-form-label" for="ph">
                권한
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions">
                <option v-for="(item, index) in codes.permissions_partner" :key="index" :value="item">{{ item }}</option>
              </select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
              <label class="col-form-label" for="">
                마지막 접속일
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.id">
              {{model.last_visit | sdate}} @ {{model.last_addr ? model.last_addr : '-'}}
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="!model.id">
              <label class="col-form-label" for="" v-if="model && !model.parent_id">
                파트너 그룹 연결
              </label>
              <label class="col-form-label" v-else>파트너 그룹 :</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="!model.id">
              <label class="col-form-label" for="" v-if="model && !model.parent_id">
                <small>생성 중인 파트너가 다른 파트너와 동일한 그룹에 속하는 경우</small>
              </label>
              <label class="col-form-label" v-else>
                {{model.parent_username}}
              </label>
              <b-button class="btn btn-sm margin_t ml-2" tabindex="4" variant="primary" @click="partner_connect_modal = true">찾기</b-button>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
              <label class="col-form-label" for="">
                파트너 그룹 소유자
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
              <label>{{model.parent_username}}</label>
              <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block :disabled="model.is_del">보기</b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username">
                사용자명(아이디)
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-1 col-md-12 align-self-center">
              <b-badge v-if="model && model.id && model.parent_id" :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * 파트너 그룹 {{model.parent_id && model.parent_id == model.id ? ' 마스터' : '멤버'}}
              </b-badge>
            </b-col>
            <b-col class="col-xl-3 col-md-12 align-self-center">
              <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" @change="change_username"></b-form-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_nickname">
                이름
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3" v-show="add || !lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_pass">
                {{add ? '' : '새'}} 비밀번호
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> 번호 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 대문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 소문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 특수문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                최소 길이 : 10 글자
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
              <label class="col-form-label" for="ph_pass2">
                비밀번호 확인
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12" v-if="model.new_password">
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_tax">
                세금 : [%]
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title_sub">
              지역
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_country">
                국가
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <select class="form-control" @input="set_country" :disabled="lock" label="name" v-model="region.country">
                <option v-for="(item, index) in codes.country" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_language">
                언어
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <select class="form-control" @input="set_language" label="name" :disabled="lock" v-model="region.language">
                <option v-for="(item, index) in codes.language" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_timezone">
                시간대
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <select class="form-control" @input="set_timezone" label="name" :disabled="lock" v-model="region.timezone">
                <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_address" v-b-tooltip.hover title="청구서를 보낼 주소에요.">
                주소
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph" v-b-tooltip.hover title="단일 IP 또는 네트워크 범위를 입력해주세요, etc) 192.168.0.100, 192.168.0.0/24 ">
                허용된 IP 목록
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex flex-wrap align-self-center">
              <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                청구할때 로고를 사용합니다.
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <img v-if="lock" class="text-center" height="120" width="400" :src="model.logo || '/f1/assets/img/F1-uwss.png'" alt="Hello, F1security">
              <b-form-group v-else>
                <!-- v-show="!confirm_save && !confirm_refresh" -->
                <picture-input
                  :z-index="2"
                  radius="3"
                  :prefill="model.logo"

                  ref="pictureInput"
                  height="140" min-height="150" width="600"  max-width="600" max-height="200"
                  accept="image/*" size="2" button-class="btn btn-dark"
                  :custom-strings="{
                    upload: '<h1>uploading</h1>',
                    drag: '<small>Drag & Drop<small>',
                  }"
                  @change="logo_change">
                </picture-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="12">
              <b-button size="sm" variant="warning"  v-if="lock && !partner" :disabled="model.is_del" @click="edit">
                {{ partner ? 'Partner' : ''}}{{ model.is_del ? '정보가 삭제되었어요' : '편집'}}
              </b-button>
              <b-button size="sm" variant="danger" @click="confirm = true" v-if="lock && !partner && !model.is_del" :disabled="model.is_del"> 삭제 </b-button>
              <b-button size="sm" class="btn btn-cancel" @click="send_password_reset_mail" v-if="lock && model.id && !partner && !model.is_del" :disabled="model.is_del"> 비밀번호 재설정 메일 보내기</b-button>
              <b-button size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="lock && model.id && !model.is_del && !partner" :disabled="model.is_del"> IP ACL 재설정 메일 보내기 </b-button>

              <b-button v-if="!lock" size="sm" variant="add" @click="save"> 저장 </b-button>
              <b-button v-if="!lock" size="sm"  variant="secondary" @click="cancel"> 취소 </b-button>
              <b-button v-if="partner" size="sm" class="m-1 pull-right" variant="primary" @click="$router.push({ name : 'partner', params : { id : partner.id } })"> 파트너 상세조회 </b-button>

              <b-button v-if="!partner" size="sm" class="m-1 pull-right" variant="primary" @click="list"> {{partner ? '파트너' : ''}} 목록 </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!-- 해당 부모 파트너와 연결되어 있는 멤버 파트너들 정보 -->
      <b-tab :disabled="!model.id" title="고객 목록">
        <b-card>
          <partner-List v-if="check_owner"  :enable_new="false" :parent_id="model.id"></partner-List> <!-- 나중에 :id="model.id"-->
          <b-row v-else>
              <b-col sm="12">
                <center>
                  <label>파트너 그룹 : [소유자]</label>
                  <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                  <b-button variant="primary" @click="reload" block>보기</b-button>
                </center>
              </b-col>
            </b-row>
        </b-card>
      </b-tab>
      <!-- 파트너 크레딧관리 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="청구 설정">
        <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto">
          </div>
        </div>
        <b-row v-if="check_owner">
          <b-col class="col-xl-6 mb-1">
            <b-card class="g">
              <b-row>
                <b-col class="col-xl-12 d-flex flex-wrap align-items-center justify-content-center">
                  <div class="title_sub">
                    결제 잔액
                    <button type="button" class="btn btn-sm btn-add ml-2" tabindex="4" @click="credit_history_modal = true">
                      내역 확인
                    </button>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col class="col-xl-12 col-md-12 d-flex flex-wrap align-items-center justify-content-center">
                  <h1 class="display-4 font-weight-bold" style="text-align: center; "><b>${{model.credit | number}}</b></h1>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="col-xl-6 mb-1">
            <b-card class="g">
              <b-row>
                <b-col class="col-xl-12 d-flex flex-wrap align-items-center justify-content-center">
                  <div class="title_sub mb-3">
                    결제 청구
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col lg="12" xl="12">
                  <b-row class="mb-2">
                    <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                      <label class="col-form-label" for="ph_name">
                        결제 입금 또는 출금
                      </label>
                    </b-col>
                    <b-col class="col-xl-8 col-md-12">
                      <b-input-group size="sm" prepend="$">
                        <b-form-input class="form-control" v-model="amount" placeholder="0.00" type="number"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                      <label class="col-form-label" for="ph_address">
                        결제 안내
                        <span class="text-danger ml-1">*</span>
                      </label>
                    </b-col>
                    <b-col class="col-xl-8 col-md-12">
                      <b-textarea class="form-control" v-model="amount_log"></b-textarea>
                    </b-col>
                  </b-row>
                  <div class="d-flex flex-wrap mt-4">
                    <div class="mr-3">
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 10">10</b-button>
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 50">50</b-button>
                      <b-button size="sm" variant="outline-info" v-on:click="amount += 100">100</b-button>
                    </div>
                    <div class="mr-3">
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 10">-10</b-button>
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 50">-50</b-button>
                      <b-button size="sm" variant="outline-warning" v-on:click="amount -= 100">-100</b-button>
                    </div>
                    <div class="pull-right ml-auto">
                      <b-button size="sm" variant="primary" @click="Credit_Add = true">업데이트</b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>파트너 그룹 : [소유자]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>보기</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 시작 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" @click="get_partner_service" title="서비스">
        <b-row v-if="check_owner">
          <b-col>
            <b-card>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title mr-auto">
                  파트너 서비스
                </div>
                <div class="mb7">
                  <span class="pull-right">가격 단위 : $</span>
                </div>
              </div>
              <hr>
              <p class="text-danger font-weight-bold">
                1. 파트너 생성 후에 가격을 정해주세요.
                <br>
                2. 서비스 공개 여부를 정할 수 있어요.
                <br>
                (가격 설정은 최초 1회만 가능해요. 단, 프로모션은 제외에요.)
                <br>
                3. 파트너가 고객을 등록하기 전에 가격을 공개해야해요.
                <br>
                4. F1의 이익은 최소한 비용으로 정해져요.
              </p>
              <div class="reg_card mt-4">
                <div class="reg_card_body">
                  <div class="table-responsive">
                    <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list_price" show-empty empty-text="결제 내역이 없어요!" :items="get_partner_service" :fields="pay">
                      <template slot="service.name" slot-scope="row">{{row.item.service.name}}</template>
                      <template slot="is_publish" slot-scope="row">
                        <!-- <c-switch color="dark" :disabled="published && row.item.is_publish && publish_list.indexOf(row.item.id) < 0" label size="sm" v-model="row.item.is_publish" @change="toggle_publish_service($event, row.item.id, row.item.is_publish)" /> -->
                        <div class="checkbox-switch">
                          <input type="checkbox" class="input-checkbox" :disabled="published && row.item.is_publish && publish_list.indexOf(row.item.id) < 0" label size="sm" v-model="row.item.is_publish" @change="toggle_publish_service($event, row.item.id, row.item.is_publish)">
                          <div class="checkbox-animate disabled">
                            <span class="checkbox-off">OFF</span>
                            <span class="checkbox-on">ON</span>
                          </div>
                        </div>
                      </template>
                      <template slot="service.min_price" slot-scope="row">{{row.item.service.min_price | dollar}} </template>
                      <template slot="customer_price" slot-scope="row">
                        <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                          <b-input size="sm" v-model="row.item.customer_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                        </b-input-group>
                      </template>
                      <template slot="benefit.f1" slot-scope="row">
                        {{ (row.item.customer_price - row.item.partner_price) | dollar}}
                        ({{(((row.item.customer_price - row.item.partner_price) / row.item.customer_price) * 100) | decimal}} %)
                      </template>
                      <template slot="benefit.partner" slot-scope="row">
                        <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
                          <b-input size="sm" v-model="row.item.partner_price" :disabled="setting_modify_index == -1 || (setting_modify && setting_modify_index != row.index)"></b-input>
                        </b-input-group>
                      </template>
                      <template slot="func" slot-scope="row">
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" size="sm" @click="price_save(row.item);" variant="outline-success">적용</b-btn>
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-if="setting_modify && setting_modify_index == row.index" @click="setting_modify = false;setting_modify_index = -1" size="sm" variant="outline-danger">취소</b-btn>
                        <b-btn class="m-1" :disabled="row.item.is_publish" v-else @click="setting_modify = true;setting_modify_index = row.index;" size="sm" variant="outline-primary">수정</b-btn>
                        <b-btn class="m-1" @click="setting_modify_confirm = true" v-if="published && row.item.is_publish && publish_list.indexOf(row.item.id) > -1" size="sm" variant="outline-warning">게시</b-btn>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <br>
              <div class="d-flex flex-wrap">
                <div class="mr-auto">
                  <b-button size="sm" :disabled="published" variant="primary" @click="setting_modify_confirm = true">
                    {{published ? '공표됨' : '공표' }}
                  </b-button>
                </div>
                <div class="">
                  <b-button v-if="published" size="sm" :disabled="!published" variant="warning" @click="service_append_confirm = true">
                    파트너에 기존 서비스 추가
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col sm="12">
            <center>
              <label>파트너 그룹 : [소유자]</label>
              <label>{{model && model.parent ? model.parent.username : '-'}}</label>
              <b-button variant="primary" @click="reload" block>보기</b-button>
            </center>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 해당 파트너의 가격 정보 끝 -->
      <!-- 해당 파트너의 그룹 정보 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="그룹 목록" @click="() => this.$refs.list && this.$refs.list.refresh()">
        <b-card>
          <group-List v-if="check_owner" :partner="model" :addPartner="true" ref="_list"></group-List>
          <b-row v-else>
            <b-col sm="12">
              <center>
                <label>파트너 그룹 : [소유자]</label>
                <label>{{model && model.parent ? model.parent.username : '-'}}</label>
                <b-button variant="primary" @click="reload" block>보기</b-button>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!-- 해당 파트너의 인보이스 목록 -->
      <b-tab :disabled="!model.id" v-if="model.id && !partner" title="청구서" @click="() => this.$refs.partner_list && this.$refs.partner_list.refresh()">
        <b-card>
          <InvoicePartnerList :ticket="true" :partner_id="model.id" ref="_list_invoice" />
          <b-button size="sm" class="pull-right" variant="primary" @click="confirm_ticket_invoice = true;" v-if="model.id"> 청구서 발행 </b-button>
        </b-card>
      </b-tab>
    </b-tabs>

    <!-- 안내 모달 시작 -->
    <b-modal title="정보 삭제"  class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소">
      해당 파트너를 삭제할까요?
    </b-modal>
    <!-- 파트너 연결 모달 -->
    <b-modal size='xl' title="파트너 연결"  class="modal-primary" v-model="partner_connect_modal" ok-only ok-variant="outline-primary" ok-title="확인">
      <partner-List :enable_new="false" @selected="select_partner" :view_detail="false"></partner-List>
    </b-modal>
    <!-- 크레딧 관련 히스토리 확인 모달 -->
    <b-modal title="[관리자 -> 파트너] 거래 내역" size="xl" v-model="credit_history_modal" ok-only @ok="credit_history_modal = false" ok-variant="outline-primary" ok-title="확인">
      <b-table class="table table_add table-striped" hover small striped responsive="sm" ref="_list_credit_history" show-empty empty-text="결제 내역이 없습니다!"
      :current-page="credit_history_opt.currentPage" :per-page="credit_history_opt.perPage"
      :items="get_credit_list" :fields="history" :sortBy="credit_history_opt.sk">
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="credit_amount" slot-scope="row">{{row.item.credit_amount | number}} </template>
        <template slot="service.list_price" slot-scope="row">{{row.item.service.list_price | number}} </template>
        <template slot="credit_info.invoice_id" slot-scope="row">{{row.item.invoice_id || '-'}} </template>
      </b-table>
      <b-row class="mt30">
        <b-col class="pagination justify-content-center">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="credit_history_opt.perPage" v-model="credit_history_opt.currentPage" prev-text="<" next-text=">"  />
        </b-col>
      </b-row>
    </b-modal>
    <!-- 크레딧 부여 확인 모달 -->
    <b-modal title="[관리자 -> 파트너] 결제 청구" v-model="Credit_Add" @ok="credit_control" ok-variant="primary" ok-title="확인" cancel-title="닫기">
      ${{amount}} 결제를 청구할까요?
    </b-modal>
    <!-- 가격 공개 부여 확인 모달 -->
    <b-modal title="파트너의 가격 공개 부여 여부" v-model="setting_modify_confirm" @ok="setting_publish" ok-variant="danger" header-bg-variant="danger">
      파트너의 가격을 공개 처리합니까?
      <hr>
      공개 처리가 완료되어야 파트너가 고객을 유치할 수 있습니다.
    </b-modal>
    <!-- 파트너 초대 메일 발송 확인 모달 -->
    <!-- <b-modal title="초대 메일" v-model="mail_confirm" @ok="send_mail" ok-variant="info">
      모든 것이 준비되었습니다.
      <hr>
      파트너에게 초대 이메일을 보내야 하나요 ({{model.username}}) ?
    </b-modal> -->
    <!-- 가격 설정 안내 모달 -->
    <b-modal title="파트너 가격 설정" no-close-on-backdrop ok-only v-model="is_registed" @ok="index = 3" ok-variant="outline-warning" header-bg-variant="warning" ok-title="확인">
      파트너에 대한 가격 설정이 유지됩니다.
      <br>
      파트너가 고객을 생성하고 관리하려면 먼저 가격 정보를 반영해야 합니다.
    </b-modal>
    <!-- 서비스 추가 모델 -->
    <!-- <b-modal title="파트너에 다른 서비스를 적용" no-close-on-backdrop ok-only v-model="service_append_confirm" @ok="service_append" ok-variant="outline-warning" header-bg-variant="warning" size="xl" ok-title="확인"> -->
      <b-modal title="기존 서비스 적용" no-close-on-backdrop ok-only v-model="service_append_confirm" @ok="service_append_confirm = false" ok-variant="outline-warning" header-bg-variant="warning" size="xl" ok-title="확인">
      <SettingService
        :view_detail="false"
        @get_basic_service="(service_id) => { this.new_service_id = service_id; service_append() }"
      />

    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="청구서 발급"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="outline-primary" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      <b-form-group>
        <p>청구서 발급 월을 선택해야해요</p>
        <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"></vue-monthly-picker> -->
        <date-picker style="width: 100%;" type="month" v-model="ticket_invoice_month" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
        <small class="text-danger font-weight-bold">
          이미 발급되었을때는 강제로 발급해요.
          <br>
          생성된 청구서의 금액을 확인하세요.
          <br>
          청구서가 발행되면 안내 메일을 보내요.
        </small>
      </b-form-group>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  height: 100%;
}
</style>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>